module.exports = __webpack_public_path__ + "img/image10.d87fce7b.png";